import { Status } from "@/types/Status"
import { Dayjs } from "dayjs"
import { TransactionStatusText } from "./transaction.parser"
import { ITransaction } from "./transaction.types"

enum TransactionType {
  Bill = "bill",
  Payment = "payment",
  Repayment = "repayment",
  Other = "other",
  Deposit = "Deposit",
  Credit = "Credit",
}

export class Transaction implements ITransaction {
  id: number
  transactionType: string
  statusText: TransactionStatusText
  reference: string
  createdDttm: Dayjs
  acceptedDttm?: Dayjs
  changeAmount: number
  accountBalance: number
  description?: string
  billId?: number
  accountCreditId: string

  private _type: TransactionType

  constructor(
    id: number,
    type: string,
    status: TransactionStatusText,
    reference: string,
    createdDttm: Dayjs,
    billId?: number,
    acceptedDttm?: Dayjs,
    creditAmount?: number,
    debitAmount?: number,
    accountBalance?: number,
    description?: string,
    accountCreditId = "",
  ) {
    this.id = id
    this.acceptedDttm = acceptedDttm
    this.createdDttm = createdDttm

    this.accountBalance = accountBalance ?? 0
    this.reference = reference
    this.description = description
    this.transactionType = type
    this.statusText = status
    this.billId = billId
    this.accountCreditId = accountCreditId

    if (creditAmount) {
      this.changeAmount = creditAmount
    } else if (debitAmount) {
      this.changeAmount = -debitAmount
    } else {
      this.changeAmount = 0
    }

    if (type === "Bill") {
      this._type = TransactionType.Bill
    } else if (type === "Payment") {
      this._type = TransactionType.Payment
    } else if (type === "Repayment") {
      this._type = TransactionType.Repayment
    } else {
      this._type = TransactionType.Other
    }
  }

  get isPayment(): boolean {
    return this._type === TransactionType.Payment
  }

  get isBill(): boolean {
    return this._type === TransactionType.Bill
  }

  get isRefund(): boolean {
    return this._type === TransactionType.Repayment
  }

  get isDeposit(): boolean {
    return this._type === TransactionType.Deposit
  }

  get isCredit(): boolean {
    return this._type === TransactionType.Credit
  }

  get isAccepted(): boolean {
    return this.statusText === "Accepted"
  }

  get isRejected(): boolean {
    return this.statusText === "Rejected"
  }

  get isFriendReferralCredit(): boolean {
    return this.reference?.toLowerCase() === "refer-a-friend"
  }

  get status(): Status {
    switch (this.statusText) {
      case "Accepted":
        return new Status("normal", this.statusText)
      case "Pending":
        return new Status("caution", this.statusText)
      case "Authorising":
        return new Status("caution", this.statusText)
      case "Rejected":
        return new Status("critical", this.statusText)
      default:
        return new Status("default", this.statusText)
    }
  }
}
